/* eslint-disable jsx-a11y/img-redundant-alt */
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { Close } from '@material-ui/icons';
import DoneIcon from '@material-ui/icons/Done';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import classnames from 'classnames';
import FeedItem from 'component/feed_item';
import BottomShareModal from 'component/share/share_bottom_modal';
import UserType from 'constants/user';
import { ItemStatus } from 'containers/style_detail/constant';
import { useGetReactionsFromStore } from 'containers/user_reactions/useGetUserLiked';
import { useAuthorize } from 'hooks/useAuthorize';
import _isEmpty from 'lodash/isEmpty';
import millify from 'millify';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { PATH } from 'routes/constant';
import themes from 'styles/themes';
import { getUserProfilePhoto } from 'utils/getUserProfilePhoto';
import { fetchImageForShare, nativeImageShare } from 'utils/share';
import styleItemUtils from 'utils/style_item';
import { useVisualViewport } from 'utils/useVisaulViewport';
import utils from 'utils/utils';
import { ReactComponent as DislikeFill } from '../../assets/svg/disliked_old.svg';
import { ReactComponent as BtnDislike } from '../../assets/svg/dislike_old.svg';
import { ReactComponent as EditStyle } from '../../assets/svg/edit_style.svg';
import { ReactComponent as BtnLikeFill } from '../../assets/svg/like_fill_v2.svg';
import { ReactComponent as BtnLike } from '../../assets/svg/like_v2.svg';
import { ReactComponent as BtnShare } from '../../assets/svg/share_v2.svg';
import { ReactComponent as BtnHanger } from '../../assets/svg/hangers.svg';
import { ReactionType, STRINGS } from '../../constants';
import { TOGGLE_REACTION } from '../../graph_ql/reaction/mutations';
import { GET_REACTION_INFORMATION } from '../../graph_ql/reaction/queries';
import { RootState, useAppDispatch, useAppSelector } from '../../redux/store';
import { PRODUCT_TYPE, trackEvent, TRACK_EVENT } from '../../utils/analytics';
import { checkIsPersonalizedStyle, getProductTrackingData } from '../../utils/trackUtils';
import { useStyles } from './style';
import { FEEDBACK_TRIGGER_TYPE, ToggleReactionResponse } from './type';
import { SEARCH_STYLE, SEARCH_STYLE_TYPE } from 'graph_ql/search/search_style';
import config from 'config';
import { useHistory } from 'react-router-dom';
import { ReactComponent as OpenNewTab } from 'assets/svg/open-new-tab.svg';
import { CREATE_TRACK_SHOP_THE_ITEM } from 'graph_ql/track_shop_the_item/mutations';
import { ReactComponent as FeedBack } from '../../assets/svg/feedback.svg';
import { ReactComponent as FeedBackView } from '../../assets/svg/feedback-view.svg';
import MultiSelectPopup from 'component/MultiSelectPopup';
import { GET_FEEDBACK_OPTIONS } from 'graph_ql/feedback_options/queries';
import { GET_FEEDBACK } from 'graph_ql/feedback/queries';
import { CREATE_FEEDBACK, UPDATE_FEEDBACK } from 'graph_ql/feedback/mutations';
import { DEFAULT_FEEDBACK_OPTION, Options } from 'component/MultiSelectPopup/types';
import WidgetPopup from 'component/popup/customize_popup';
import { WidgetCode } from 'component/popup/constant';
import { Feedback, FeedbackReason } from 'graph_ql/feedback/types';
import { Collection, Currency } from '../../containers/user_reactions/types';
import { resetRequestQuiz, setRequestQuizPath, setSessionSource } from 'redux/style_request_quiz/requestQuiz.slice';
import { REQUEST_PATH, SESSION_QUIZ_PATH } from 'containers/session_quiz/constants';
import { setCurrentEditingItemId } from '../../redux/create-style/create-style.slice';
import { useUrlQuery } from '../../hooks/useUrlQuery';
import clsx from 'clsx';
import DynamicLayoutItemDetail from 'containers/style_detail/dynamic_layout_item_detail';
import useConfigurationData from '../../hooks/useConfigurationData';
import { DynamicLayoutVersion } from '../../types/types';
import CanvasLayoutStyle from 'containers/style_detail/canvas_layout_style';
import { pick } from 'lodash';

// ToDo: why not pass the entire style or item object ?
export interface IProps {
    styleItemData: any;
    heightContent: any;
    handleViewDetail: any;
    handleClick: any;
    handleAddtobag: any;
    handleViewInfo: Function;
    handleSendMessageWA: (item, trackEventParams, user, styleTaffiId) => void;
    setTitle: Function;
    setLoadingReact?: Function;
    handleClickStylist: any;
    handleStyleStatus?: any;
    itemIndex?: number;
    showAddedPopup?: any;
    inputSearch?: String;
    isItemOnly?: boolean;
}
function StyleItem({
    styleItemData,
    heightContent,
    handleViewDetail,
    handleClick,
    handleAddtobag,
    handleViewInfo,
    handleSendMessageWA,
    setTitle,
    handleClickStylist,
    handleStyleStatus,
    itemIndex,
    inputSearch,
    isItemOnly,
}: IProps) {
    const { stitcher } = useConfigurationData();
    const style_name = styleItemData.title;
    const creator = styleItemData.creator;
    const listItems = styleItemData.items;
    const collection = styleItemData.collection;
    const id = styleItemData.id;
    const taffiId: string = styleItemData.taffiId;
    const user = styleItemData.user;
    const imageJson = styleItemData.imageJson;
    const isDynamicLayout =
        collection === Collection.Styles &&
        (stitcher.dynamicLayoutVersion === DynamicLayoutVersion.v2 ||
            (styleItemData?.user?.id === process.env.REACT_APP_SHOPIFY_STYLIST_ID && !styleItemData.images?.length));
    const priceRef = useRef<HTMLDivElement>(null);
    const dispatch = useAppDispatch();
    const classes = useStyles();
    const [activeItem, setActiveItem] = useState(0);
    const [itemTaffiId, setItemTaffiId] = useState('');
    const [list, setList] = useState(listItems);
    const userDetail = useSelector((state: RootState) => state.userDetail.me);
    const authorize = useAuthorize();
    const location: any = useLocation();
    const [isShowMultiple, setIsShowMultiple] = useState(false);
    const { userName } = useParams<{ userName: string }>();
    const [isEditable, setIsEditable] = useState<boolean>(true);
    const [listStyle, setListStyle] = useState<any[]>([]);
    const [feedbackPopupShow, setFeedbackPopupShow] = useState<boolean>(false);
    const [feedbackOptions, setFeedbackOptions] = useState<FeedbackReason[]>([]);
    const [feedBack, setFeedback] = useState<Feedback | null>(null);
    const [selectedFeedbacks, setSelectedFeedbacks] = useState<Options>(DEFAULT_FEEDBACK_OPTION);
    const [customValueError, setCustomValueError] = useState<boolean>(false);
    const [consumersFeedbacksPopupShow, setConsumersFeedbacksPopupShow] = useState<boolean>(false);
    const [dislikedFeedbackDoc, setDislikedFeedbackDoc] = useState<{
        docId: string;
        collectionName: string;
        taffiId: string;
    } | null>(null);
    const [showDynamicItemDetail, setShowDynamicItemDetail] = useState<any>(null);

    const isOwner = Boolean(userDetail && userDetail.userType === UserType.Stylist && creator === userDetail.id);
    const isCustomer = Boolean(userDetail && userDetail.userType === UserType.Customer);
    const history = useHistory();
    const searchQuery = useUrlQuery();

    const { updateAfterReaction, reactedItems } = useGetReactionsFromStore();

    const [createTrackShopTheItem] = useMutation(CREATE_TRACK_SHOP_THE_ITEM);
    const storeId = useAppSelector((state: RootState) => state.widget.store?.id);
    const taffiStoreId = useSelector((state: RootState) => state.global.taffiStoreId);
    const storeSourceUrl = useSelector((state: RootState) => state.widget?.sourceUrl);

    const isItemOwner = (item) => {
        return (
            item?.data?.collection === 'items' &&
            (item?.data?.creator === userDetail?.id ||
                (item?.data?.storeId &&
                    userDetail?.userType === UserType.Stylist &&
                    (userDetail?.stores || []).map((s) => s?.id).includes(item?.data?.storeId)))
        );
    };
    const isConsumerUploadedItem = (item) => {
        return item?.data?.collection === 'items' && item?.data?.user?.userType === UserType.Customer;
    };

    useEffect(() => {
        if (!userDetail) {
            sessionStorage.setItem('from', JSON.stringify({ from: location }));
            setTitle('Taffi Style');
        }
    }, [location, setTitle, userDetail]);

    useEffect(() => {
        setList(utils.generateListItem(listItems, id, imageJson, isItemOnly, collection, styleItemData));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listItems]);

    const onSetActiveItem = (activeItem: number) => {
        const item = getActiveItem(list, activeItem);
        const productViewTrackingData = {
            ...getProductTrackingInfo(item),
            personalized: checkIsPersonalizedStyle(item, userDetail),
        };
        trackEvent(TRACK_EVENT.PRODUCT_VIEW, productViewTrackingData);
        //trackEvent(TRACK_EVENT.STYLIST_CONSULT_REQUEST, getProductTrackingInfo(item));
        return setActiveItem(activeItem);
    };

    const getActiveItem = (listItems: any[], activeItem: any): any => {
        return listItems[activeItem];
    };

    const getActiveItemIndex = () => {
        return isItemOnly ? 1 : activeItem;
    };

    const getProductTrackingInfo = (item) => {
        const trackStyleLayoutVersion = true;
        return getProductTrackingData(
            userDetail,
            item?.collection === 'styles'
                ? {
                    ...item,
                    taffiId: taffiId,
                    creator: String(creator),
                }
                : {
                    ...item?.data,
                },
            { taffiId, id, user: item?.data?.user },
            trackStyleLayoutVersion,
        );
    };

    const handleView = (item) => {
        if (item?.collection === 'styles') {
            handleViewDetail(list);
        } else if (isItemOwner(item) || isOwner) {
            if (collection === Collection.Styles) {
                if (item.id) {
                    dispatch(setCurrentEditingItemId(item.id));
                }
                history.push(`${PATH.EDIT_STYLE_CANVAS}/${taffiId}`);
            } else {
                history.push(`${PATH.EDIT_ITEM}/${item?.data?.taffiId}`);
            }
        } else {
            if (item?.data?.currency !== Currency.Sar || config.removeCheckOut) {
                trackEvent(TRACK_EVENT.SHOP_THE_PRODUCT, {
                    product_type: PRODUCT_TYPE.ITEM,
                    contextType: PRODUCT_TYPE.STYLE,
                    contextId: id,
                    contextTaffiId: taffiId,
                    product: pick(item.data, ['id', 'taffiId', 'title', 'price', 'currency', 'url']),
                    recommendationSource: location.pathname,
                });
                if (storeId || taffiStoreId) {
                    createTrackShopTheItem({
                        variables: {
                            input: {
                                itemId: item.id,
                                storeId: storeId || taffiStoreId,
                            },
                        },
                    });
                }
                const itemUrl = new URL(item?.data?.url);
                if (!userDetail) {
                    itemUrl?.searchParams?.append(config.widgetConstants.WIDGET_INITIAL_CLOSED, 'true');
                    let taffiPath = `${PATH.DISCOVER_YOUR_STYLE}?taffiId=${taffiId}`;
                    if (location.pathname === PATH.STYLE_IT_RIGHT) {
                        const sourceProductUrl =
                            location?.state?.sourceProductURL || searchQuery.get('sourceProductUrl');
                        taffiPath = `${PATH.STYLE_IT_RIGHT}?taffiId=${taffiId}&sourceProductUrl=${sourceProductUrl}`;
                    }
                    if (itemUrl?.searchParams.get(config.widgetConstants.TAFFI_PATH)) {
                        itemUrl?.searchParams.set(config.widgetConstants.TAFFI_PATH, taffiPath);
                    } else {
                        itemUrl?.searchParams.append(config.widgetConstants.TAFFI_PATH, taffiPath);
                    }
                } else {
                    if (itemUrl?.searchParams.get(config.widgetConstants.TAFFI_CONTEXT)) {
                        itemUrl?.searchParams.set(config.widgetConstants.TAFFI_CONTEXT, taffiId);
                    } else {
                        itemUrl?.searchParams.append(config.widgetConstants.TAFFI_CONTEXT, taffiId);
                    }
                }
                window.open(itemUrl.href);
            } else {
                handleViewDetail([item], getActiveItemIndex() === 0 ? null : item.id);
            }
        }
    };

    const handleViewImage = (image) => {
        handleClick(image);
    };

    // todo: remove this function if confirmed to remove the REQUEST A STYLE button
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const handleRequestStyle = (stylistId) => {
        if (!authorize.isAuthorize) {
            authorize.navigateEffect();
            return;
        } else {
            dispatch(resetRequestQuiz());
            dispatch(setSessionSource(location));
            dispatch(setRequestQuizPath(SESSION_QUIZ_PATH.SESSION_PURPOSE));
            history.push(`${PATH.STYLE_REQUEST_QUIZ}/?path=${REQUEST_PATH.SESSION_PURPOSE.param}`, {
                stylistId: stylistId,
            });
        }
    };

    const handleRelatedStyles = async (itemTaffiId) => utils.openLinkInNewTab(`${PATH.RELATED_STYLES}/${itemTaffiId}`);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const isReactionsPage = useMemo(
        () => utils.checkCurrentPage(PATH.USER_LIKES) || utils.checkCurrentPage(PATH.USER_DISLIKES),
        [],
    );
    const [reaction, setReaction] = useState({ like: false, dislike: false, totalLike: 0, totalDislike: 0 });
    const [toggleReactionMutation, { loading: toggleReactionLoading }] = useMutation<ToggleReactionResponse>(
        TOGGLE_REACTION,
        {
            onError: (err) => {
                console.error(err);
            },
        },
    );

    const itemVariable = {
        // ToDo: why collection field is missing from the list.collection ?
        collectionName: list[activeItem]?.collection || 'items',
        docId: list[activeItem]?.id,
    };
    useEffect(() => {
        if (!itemVariable.docId) {
            trackEvent(TRACK_EVENT.BUSINESS_ERROR, {
                itemVariable,
                list: (list || []).map((l: any) => l.id),
                activeItem,
                style_name,
                styleItemDataId: styleItemData.id,
                taffiId,
                collection,
            });
        }
        // eslint-disable-next-line
    }, [itemVariable.docId]);
    const { refetch } = useQuery(GET_REACTION_INFORMATION, {
        variables: { ...itemVariable },
        onCompleted: (data) => {
            if (data?.getReactionInformation?.reactionState) {
                const { isAlreadyLike, isAlreadyDislike } = data.getReactionInformation.reactionState;
                const { totalLike, totalDislike } = data.getReactionInformation.reactionNumber;
                setReaction({
                    like: isAlreadyLike,
                    dislike: isAlreadyDislike,
                    totalLike,
                    totalDislike,
                });
            }
        },
        fetchPolicy: 'cache-and-network',
        skip: !itemVariable.docId || !userDetail,
    });

    const handleReaction = async (action: ReactionType) => {
        if (!authorize.isAuthorize) {
            authorize.navigateEffect();
            return;
        }
        setDislikedFeedbackDoc({
            docId: itemVariable?.docId,
            collectionName: itemVariable?.collectionName,
            taffiId: list[activeItem]?.data?.taffiId,
        });
        const variables = {
            input: {
                ...itemVariable,
                type: action,
                contextType: isItemOnly ? PRODUCT_TYPE.ITEM : PRODUCT_TYPE.STYLE,
                contextId: id,
                contextTaffiId: taffiId,
            },
        };

        if (itemVariable.docId) {
            if (action === ReactionType.Like) {
                setReaction({ ...reaction, like: !reaction.like, dislike: false });
            } else {
                setReaction({ ...reaction, like: false, dislike: !reaction.dislike });
            }

            const response = await toggleReactionMutation({ variables });

            // Remove likes from likedItems
            if (isReactionsPage && response.data) {
                updateAfterReaction(
                    response.data,
                    utils.checkCurrentPage(PATH.USER_LIKES) ? ReactionType.Like : ReactionType.Dislike,
                );
            }
            // await refetch()
            if (response?.data?.toggleReaction?.reactionState) {
                const { isAlreadyLike, isAlreadyDislike } = response?.data?.toggleReaction?.reactionState;
                const { totalLike, totalDislike } = response?.data?.toggleReaction?.reactionNumber;
                setReaction({
                    like: isAlreadyLike,
                    dislike: isAlreadyDislike,
                    totalLike,
                    totalDislike,
                });
                if (isAlreadyDislike) {
                    handleOpenFeedback(FEEDBACK_TRIGGER_TYPE.DISLIKE, itemVariable?.collectionName);
                } else {
                    refetchCustomerFeedbacks();
                }
            }
        }
    };

    useEffect(() => {
        if (isReactionsPage) {
            refetch();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reactedItems, isReactionsPage]);

    useEffect(() => {
        let title = getActiveItem(list, activeItem)?.collection === 'styles' ? 'Style' : 'Item';
        if (!authorize.isAuthorize) {
            title = 'Taffi ' + title;
        }
        setTitle(title);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeItem, list]);
    useEffect(() => {
        if (!_isEmpty(styleItemData) && activeItem) {
            setItemTaffiId(styleItemData?.items[activeItem - 1]?.data?.taffiId);
        }
    }, [activeItem, styleItemData]);

    const searchVariables = useMemo(() => {
        // used for styles corresponding WEBAPP-892
        setListStyle([]);
        let index = 'styles';
        let itemIndex: number;
        if (styleItemData?.collection === 'items') {
            itemIndex = activeItem;
        } else {
            itemIndex = activeItem - 1;
        }

        return {
            __typename: SEARCH_STYLE_TYPE.algolia_styles,
            index: config.algolia.algolia_prefix + index,
            query: styleItemData?.items[itemIndex]?.data?.taffiId,
            filters: `status:published`,
            hit: config.algoliaHitPerPage,
            page: 0,
            facets: [],
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [styleItemData, activeItem]);

    useQuery(SEARCH_STYLE, {
        variables: searchVariables,
        context: {
            scope: 'private',
        },
        onCompleted(response) {
            setListStyle(response?.locationsInRadius?.hits);
        },
        skip: !isCustomer,
    });

    const userData = useSelector((state: RootState) => state.userDetail.me);
    const url = useMemo(() => {
        if ((utils.isAppInWidgetMode() && storeSourceUrl?.length > 0) || !utils.isAppInWidgetMode()) {
            return getActiveItemIndex() && isItemOnly
                ? utils.getShareEntityUrl('/item', taffiId)
                : getActiveItemIndex()
                    ? utils.getShareEntityUrlWithParams('/item', itemTaffiId, `styleTaffiId=${taffiId}`, taffiId)
                    : utils.getShareEntityUrl('/style', taffiId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isItemOnly, storeSourceUrl, taffiId, itemTaffiId, activeItem]);
    const createShareMessage = () => {
        const label = !getActiveItemIndex() ? 'style' : 'item';
        let message = `Hey,\n\nCheck out this cool ${label} on Taffi: ${url} ${
            userData ? `\n\n- ${userData?.firstName} ${userData?.lastName}` : ''
        }`;
        return message;
    };

    // Get Share Image
    const [shareImage, setShareImage] = useState<File | null>(null);
    const [gettingShareImage, setGettingShareImage] = useState(false);

    const getShareImage = async () => {
        try {
            setGettingShareImage(true);
            const imageFile = await fetchImageForShare(list[activeItem]?.data?.images[0]);
            setShareImage(imageFile as File);
        } catch (error) {
            console.error(error);
        } finally {
            setGettingShareImage(false);
        }
    };

    // Sharing related codes
    const [sharing, setSharing] = useState(false);
    const shareStyle = async () => {
        const title = !getActiveItemIndex()
            ? `Taffi Style: ${style_name}`
            : `Taffi Item: ${list[activeItem]?.data?.title}`;
        // const image = list[activeItem]?.data?.images[0];
        const url = utils.getShareEntityUrl('/style', taffiId);
        if (!!navigator?.share) {
            await nativeImageShare({
                text: title + '\n\n' + createShareMessage(),
                url: url,
                image: shareImage!,
                title: title,
            });
        }
    };
    const screenWidth = useVisualViewport();
    const [widthTitle, setWidthTitle] = useState(0);
    useEffect(() => {
        const temp = document.getElementById('header')?.offsetWidth;
        if (getActiveItem(list, activeItem)?.collection && temp) {
            setWidthTitle(temp);
        } else {
            const priceWidth = document.getElementById('price')?.offsetWidth;
            if (temp && priceWidth) {
                setWidthTitle(temp - priceWidth);
            }
        }
    }, [activeItem, list, screenWidth.viewport.width]);

    const handleMultiImage = () => {
        setIsShowMultiple(!isShowMultiple);
    };
    const handleSelectImg = (idx) => {
        const dataTemp = [...list];
        setList(
            dataTemp.map((item) => {
                if (item.id === getActiveItem(list, activeItem).id) {
                    return {
                        ...item,
                        indexSelect: idx,
                    };
                } else {
                    return { ...item };
                }
            }),
        );
    };

    const handleStyleItemInfoClick = () => {
        const styleItemInfo = getActiveItem(list, activeItem);
        handleViewInfo(styleItemInfo);
    };
    useEffect(() => {
        if (!userData?.id) {
            setIsEditable(true);
            return;
        }
        if (
            activeItem !== 0 &&
            styleItemData?.items[activeItem - 1]?.data?.creator !== userData?.id &&
            !styleItemData?.items[activeItem - 1]?.data?.storeId &&
            !isCustomer
        ) {
            setIsEditable(false);
        } else {
            setIsEditable(true);
        }
    }, [activeItem, styleItemData, userData, isCustomer]);

    const handleOpenFeedback = (type: FEEDBACK_TRIGGER_TYPE, collectionName: string) => {
        if (!authorize.isAuthorize) {
            authorize.navigateEffect();
            return;
        }
        getFeedbackOptions({
            variables: {
                input: {
                    targetType: [collectionName],
                },
            },
        });
        if (isCustomer) setFeedbackPopupShow(true);
        trackEvent(TRACK_EVENT.FEEDBACK_OPEN, {
            userInfo: {
                userId: userDetail?.id,
                gender: userDetail?.gender,
                email: userDetail?.email,
                name: `${userDetail?.firstName} ${userDetail?.lastName}`,
                userType: userDetail?.userType,
            },
            targetInfo: {
                type: dislikedFeedbackDoc?.collectionName || list[activeItem]?.collection || 'items',
                ID: dislikedFeedbackDoc?.docId || list[activeItem]?.id,
                taffiID: dislikedFeedbackDoc?.taffiId || list[activeItem]?.data?.taffiId,
            },
            stylistInfo: {
                stylistId: user?.id,
                stylistEmail: user?.email,
            },
            trigger: type,
        });
    };

    const feedbackVariables = useMemo(() => {
        return {
            collectionName: dislikedFeedbackDoc?.collectionName || list[activeItem]?.collection || 'items',
            docId: dislikedFeedbackDoc?.docId || list[activeItem]?.id,
        };
    }, [list, activeItem, dislikedFeedbackDoc]);

    useEffect(() => {
        if (isCustomer && feedbackVariables.collectionName && feedbackVariables.docId) {
            getCustomerFeedback({
                variables: {
                    input: feedbackVariables,
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [feedbackVariables, isCustomer]);

    const [getFeedbackOptions, { loading: getFeedbackOptionsLoading }] = useLazyQuery(GET_FEEDBACK_OPTIONS, {
        fetchPolicy: 'network-only',
        onCompleted(response) {
            setFeedbackOptions(response?.getFeedbackOptions);
        },
        onError(error) {
            console.error('Get Feedback Options Error', error);
        },
    });

    const [getCustomerFeedback, { loading: getCustomerFeedbackLoading, refetch: refetchCustomerFeedbacks }] =
        useLazyQuery(GET_FEEDBACK, {
            fetchPolicy: 'no-cache',
            onCompleted(response) {
                setFeedback(response?.getFeedback || {});
                setSelectedFeedbacks({
                    options: response?.getFeedback?.feedbackReasons || [],
                    customValue: response?.getFeedback?.feedbackSubReason || '',
                });
            },
            onError(error) {
                console.error('Get Feedback Error', error);
            },
        });

    const [createFeedback, { loading: createFeedbackLoading }] = useMutation(CREATE_FEEDBACK, {
        onCompleted(response) {
            setFeedback(response?.createFeedback || {});
        },
    });

    const [updateFeedback, { loading: updateFeedbackLoading }] = useMutation(UPDATE_FEEDBACK, {
        onCompleted(response) {
            setFeedback(response?.updateFeedback || {});
        },
    });

    const handleSubmitFeedback = async () => {
        const hasCustomFeedback = selectedFeedbacks?.options?.find((op) => op?.value === 'Other') !== undefined;
        if (!selectedFeedbacks?.customValue?.length && hasCustomFeedback) {
            setCustomValueError(true);
        } else {
            setCustomValueError(false);
            if (feedBack?.id) {
                await updateFeedback({
                    variables: {
                        input: {
                            id: feedBack?.id,
                            feedbackReasonIds: selectedFeedbacks?.options?.map((op) => op?.id),
                            feedbackSubReason: hasCustomFeedback ? selectedFeedbacks?.customValue : '',
                        },
                    },
                });
            } else {
                if (!selectedFeedbacks?.options?.length) return;
                await createFeedback({
                    variables: {
                        input: {
                            ...feedbackVariables,
                            contextType: isItemOnly ? PRODUCT_TYPE.ITEM : PRODUCT_TYPE.STYLE,
                            contextId: id,
                            contextTaffiId: taffiId,
                            feedbackReasonIds: selectedFeedbacks?.options?.map((op) => op?.id),
                            feedbackSubReason: hasCustomFeedback ? selectedFeedbacks?.customValue : '',
                        },
                    },
                });
            }
        }
    };

    const handleCloseMultiSelectPopup = () => {
        setDislikedFeedbackDoc(null);
        setFeedbackPopupShow(false);
    };

    const handleViewFeedbackByStylist = () => {
        setConsumersFeedbacksPopupShow(true);
        trackEvent(TRACK_EVENT.FEEDBACK_VIEW, {
            targetInfo: {
                type: list[activeItem]?.collection || 'items',
                ID: list[activeItem]?.id,
                taffiID: list[activeItem]?.data?.taffiId,
            },
            stylistInfo: {
                stylist_id: user?.id,
                stylist_email: user?.email,
            },
            userInfo: {
                userId: userDetail?.id,
                email: userDetail?.email,
                name: `${userDetail?.firstName} ${userDetail?.lastName}`,
                userType: userDetail?.userType,
            },
        });
    };

    const renderButtons = (item) => {
        if (isConsumerUploadedItem(item) && !isItemOwner(item)) {
            return null;
        }
        if (
            !userName &&
            (!userDetail || (userDetail && (userDetail.userType === UserType.Customer || isOwner || isItemOwner(item))))
        )
            return (
                <>
                    <button
                        className={classes.editOrAddButton}
                        disabled={!isEditable}
                        // onClick={() => { getActiveItem(list, activeItem)?.collection === "styles" ? handleAddtobag(listItems) : handleAddtobag([renderPrice(list, activeItem)]) }}
                        style={{
                            width: '100%',
                            height: '48px',
                            padding: '15px 0',
                            color: 'white',
                            fontSize: 14,
                            fontWeight: '500',
                            fontFamily: 'PoppinsRegular',
                            background: themes.palette.primary.main,
                            border: 'none',
                            borderRadius: '29px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                        onClick={() => handleView(item)}
                    >
                        {isOwner || isItemOwner(item) ? (
                            <>
                                <EditStyle style={{ color: 'white', marginRight: 8 }} />
                                {getActiveItemIndex() === 0 ? STRINGS.EDIT_STYLE : STRINGS.EDIT_ITEM}
                            </>
                        ) : item?.collection === 'styles' ? (
                            STRINGS.SHOP_STYLE
                        ) : (
                            <span
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                {STRINGS.SHOP_ITEM}
                                {(utils.isAppInWidgetMode() ||
                                    item?.data?.currency !== Currency.Sar ||
                                    config.removeCheckOut) && <OpenNewTab style={{ marginLeft: 8 }} />}
                            </span>
                        )}
                    </button>
                    {/*{!isItemOwner(item) &&*/}
                    {/*    !utils.isAppInWidgetMode() &&*/}
                    {/*    isCustomer &&*/}
                    {/*    item?.data?.user?.approved &&*/}
                    {/*    item?.data?.user?.availableForStylingSessions && (*/}
                    {/*    <button*/}
                    {/*        className={classes.buttonConsult}*/}
                    {/*        onClick={() => {*/}
                    {/*            handleRequestStyle(item?.data?.creator);*/}
                    {/*        }}*/}
                    {/*    >*/}
                    {/*        {STRINGS.REQUEST_A_STYLE}*/}
                    {/*    </button>*/}
                    {/*)}*/}
                </>
            );
    };

    return (
        <div
            style={{
                padding: '5px 24px 6px 24px',
                height: `${heightContent}px`,
            }}
        >
            <div className={classes.styleContainer}>
                <div
                    className={clsx({
                        [classes.styleHeader]: true,
                        [classes.borderBottom]: !isDynamicLayout,
                    })}
                    id="header"
                >
                    <div className={classes.user} style={{ width: `${widthTitle}px` }}>
                        <div className={classes.avatar} style={{ width: 40 }}>
                            <img
                                src={getUserProfilePhoto(user)}
                                style={{ width: 40, height: 'auto', borderRadius: '50%' }}
                                alt="stylist avatar"
                                onClick={handleClickStylist}
                            />
                        </div>
                        <div className={classes.title} style={{ width: `${widthTitle - 48}px` }}>
                            <p className={classes.titleDetail}>
                                {getActiveItem(list, activeItem)?.collection
                                    ? style_name
                                    : getActiveItem(list, activeItem)?.data?.title}{' '}
                                {styleItemData.status === ItemStatus.Draft ? ' (In Draft)' : ''}
                            </p>
                            <p
                                className={classes.titleDetail}
                                style={{ opacity: 0.5, wordWrap: 'break-word' }}
                                onClick={handleClickStylist}
                            >
                                {user?.firstName || ''} {user?.lastName || ''}
                            </p>
                        </div>
                    </div>
                    {isDynamicLayout && (
                        <div className={classes.headerActionContainer}>
                            <span className={classes.headerActionIcon} onClick={handleStyleItemInfoClick}>
                                <InfoOutlinedIcon
                                    style={{ color: themes.palette.primary.main, width: 24, height: 24 }}
                                />
                            </span>
                            {url?.length && (
                                <span
                                    onClick={async () => {
                                        setSharing(true);
                                        getShareImage();
                                    }}
                                    className={classes.headerActionIcon}
                                    style={{ color: themes.palette.primary.main }}
                                >
                                    <BtnShare style={{ width: 24, height: 24 }} />
                                </span>
                            )}
                        </div>
                    )}
                    {!getActiveItem(list, activeItem)?.collection && (
                        <div
                            ref={priceRef}
                            style={{ width: 'auto', display: 'flex', justifyContent: 'flex-end' }}
                            id="price"
                        >
                            <span className={classes.price}>
                                {utils.getPrice(
                                    styleItemUtils.getInfo(getActiveItem(list, activeItem), 'price')?.price as number,
                                    styleItemUtils.getInfo(getActiveItem(list, activeItem), 'currency')?.currency,
                                )}
                            </span>
                        </div>
                    )}
                </div>
                <div
                    className={classes.styleContent}
                    style={{
                        ...(isDynamicLayout
                            ? {
                                display: 'flex',
                                flex: 1,
                                alignItems: 'center',
                                justifyContent: 'center',
                            }
                            : {}),
                    }}
                >
                    <div
                        style={{
                            height: `${heightContent - 201}px`,
                            width: '100%',
                            position: 'relative',
                        }}
                    >
                        {isDynamicLayout ? (
                            <CanvasLayoutStyle
                                style={styleItemData}
                                items={list}
                                heightContent={heightContent - 201}
                                setShowDynamicItemDetail={setShowDynamicItemDetail}
                                onSetActiveItem={onSetActiveItem}
                            />
                        ) : (
                            <FeedItem
                                heightContent={heightContent - 201}
                                listItems={list}
                                setActiveItem={onSetActiveItem}
                                handleClick={handleViewImage}
                                itemIndex={itemIndex}
                                inputSearch={inputSearch}
                                handleMultiImage={() => setIsShowMultiple(false)}
                            />
                        )}
                        <div
                            className={classes.actions}
                            style={{
                                justifyContent: `${isShowMultiple ? 'flex-end' : 'space-between'}`,
                                right: isDynamicLayout ? 16 : 0,
                            }}
                        >
                            {!isShowMultiple ? (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        flexDirection: 'column',
                                        flex: 1,
                                    }}
                                >
                                    {!isDynamicLayout && (
                                        <>
                                            <span className={classes.actionsIcon} onClick={handleStyleItemInfoClick}>
                                                <InfoOutlinedIcon style={{ color: themes.palette.primary.main }} />
                                            </span>
                                            {isOwner && !userName ? (
                                                <span className="d-flex flex-column align-items-center">
                                                    <span className={classes.actionsIcon} onClick={() => null}>
                                                        <BtnLikeFill />
                                                    </span>
                                                    <div className={classes.actionStatistic}>
                                                        {millify(reaction.totalLike)}
                                                    </div>
                                                </span>
                                            ) : userDetail && isCustomer ? (
                                                <span
                                                    className={classnames(classes.actionsIcon, {
                                                        [classes.disabled]: toggleReactionLoading,
                                                        [classes.marginTop16]: isDynamicLayout,
                                                    })}
                                                    onClick={() => {
                                                        handleReaction(ReactionType.Like);
                                                    }}
                                                >
                                                    {reaction.like ? <BtnLikeFill /> : <BtnLike />}
                                                </span>
                                            ) : null}
                                            {isOwner && !userName ? (
                                                <span className="d-flex flex-column align-items-center">
                                                    <span className={classes.actionsIcon} onClick={() => null}>
                                                        <DislikeFill style={{ width: 22 }} />
                                                    </span>
                                                    <div className={classes.actionStatistic}>
                                                        {millify(reaction.totalDislike)}
                                                    </div>
                                                </span>
                                            ) : userDetail && isCustomer ? (
                                                <span
                                                    className={classnames(classes.actionsIcon, {
                                                        [classes.disabled]: toggleReactionLoading,
                                                        [classes.marginTop16]: isDynamicLayout,
                                                    })}
                                                    onClick={() => {
                                                        handleReaction(ReactionType.Dislike);
                                                    }}
                                                >
                                                    {reaction.dislike ? (
                                                        <DislikeFill style={{ width: 22 }} />
                                                    ) : (
                                                        <BtnDislike style={{ width: 22 }} />
                                                    )}
                                                </span>
                                            ) : null}
                                        </>
                                    )}
                                    {isOwner && !userName ? (
                                        <span className={classes.actionsIcon} onClick={handleViewFeedbackByStylist}>
                                            <FeedBackView style={{ width: 22 }} />
                                        </span>
                                    ) : (!userDetail || isCustomer) && reaction.dislike ? (
                                        <span
                                            className={classes.actionsIcon}
                                            onClick={() =>
                                                handleOpenFeedback(
                                                    FEEDBACK_TRIGGER_TYPE.FEEDBACK,
                                                    getActiveItem(list, activeItem)?.data?.collection,
                                                )
                                            }
                                        >
                                            {feedBack?.id ? (
                                                <FeedBackView style={{ width: 22 }} />
                                            ) : (
                                                <FeedBack style={{ width: 22 }} />
                                            )}
                                        </span>
                                    ) : null}
                                    {!isDynamicLayout && url?.length && (
                                        <span
                                            onClick={async () => {
                                                setSharing(true);
                                                getShareImage();
                                            }}
                                            className={classes.actionsIcon}
                                            style={{ color: themes.palette.primary.main }}
                                        >
                                            <BtnShare />
                                        </span>
                                    )}
                                    {isOwner &&
                                        !userName &&
                                        styleItemData?.status &&
                                        styleItemData?.status !== ItemStatus.Draft && (
                                        <span className={classes.actionsIcon} onClick={handleStyleStatus}>
                                            <DoneIcon
                                                style={{
                                                    fontSize: '18px',
                                                    color:
                                                            styleItemData?.status === ItemStatus.Published ||
                                                            styleItemData?.status === ItemStatus.PublishToConsumers ||
                                                            styleItemData?.status === ItemStatus.PublishToUnlisted
                                                                ? themes.palette.primary.main
                                                                : themes.palette.grey['500'],
                                                }}
                                            />
                                        </span>
                                    )}
                                </div>
                            ) : (
                                <div className={classes.multiple}>
                                    {getActiveItem(list, activeItem)?.data.images?.length > 0 &&
                                        getActiveItem(list, activeItem)?.data?.images.map((item, index) => (
                                            <div key={index} className={classes.multipleItem}>
                                                <img
                                                    src={item}
                                                    style={{
                                                        width: 42,
                                                        height: 42,
                                                        borderRadius: '50%',
                                                        border: `1px solid ${themes.palette.primary.main}`,
                                                    }}
                                                    alt="style image"
                                                    onClick={() => handleSelectImg(index)}
                                                />
                                            </div>
                                        ))}
                                </div>
                            )}
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                {getActiveItem(list, activeItem)?.data?.collection === 'items' &&
                                    listStyle?.length > 1 &&
                                    isCustomer && (
                                    <span
                                        className={classes.actionsIcon}
                                        onClick={() => {
                                            handleRelatedStyles(getActiveItem(list, activeItem)?.data?.taffiId);
                                        }}
                                    >
                                        <BtnHanger />
                                    </span>
                                )}
                                {getActiveItem(list, activeItem)?.data?.collection === 'items' &&
                                    getActiveItem(list, activeItem)?.data?.images?.length > 1 &&
                                    (isShowMultiple ? (
                                        <span className={classes.actionsIcon}>
                                            <Close onClick={() => handleMultiImage()} />
                                        </span>
                                    ) : (
                                        <span className={classes.actionsIcon} style={{ padding: 0, cursor: 'pointer' }}>
                                            <img
                                                src={
                                                    getActiveItem(list, activeItem)?.data?.images[
                                                        getActiveItem(list, activeItem).indexSelect
                                                    ]
                                                }
                                                style={{
                                                    width: 42,
                                                    height: 42,
                                                    borderRadius: '50%',
                                                    border: `1px solid ${themes.palette.primary.main}`,
                                                }}
                                                alt="style image"
                                                onClick={() => handleMultiImage()}
                                            />
                                        </span>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={classes.styleAction}>
                    {isDynamicLayout && (
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            {isOwner && !userName ? (
                                <span
                                    className="d-flex flex-column align-items-center"
                                    style={{ position: 'relative', width: 'calc(50% - 6px)' }}
                                >
                                    <span
                                        className={classes.actionsIconV2}
                                        style={{ width: '100%' }}
                                        onClick={() => null}
                                    >
                                        <BtnLikeFill />
                                    </span>
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: 'calc(50% + 20px)',
                                            transform: 'translate(-50%, -50%)',
                                        }}
                                        className={classes.actionStatistic}
                                    >
                                        {millify(reaction.totalLike)}
                                    </div>
                                </span>
                            ) : userDetail && isCustomer ? (
                                <span
                                    className={classnames(classes.actionsIconV2, {
                                        [classes.disabled]: toggleReactionLoading,
                                    })}
                                    onClick={() => {
                                        handleReaction(ReactionType.Like);
                                    }}
                                >
                                    {reaction.like ? <BtnLikeFill /> : <BtnLike />}
                                </span>
                            ) : null}
                            {isOwner && !userName ? (
                                <span
                                    className="d-flex flex-column align-items-center"
                                    style={{ position: 'relative', width: 'calc(50% - 6px)' }}
                                >
                                    <span
                                        className={classes.actionsIconV2}
                                        style={{ width: '100%' }}
                                        onClick={() => null}
                                    >
                                        <DislikeFill style={{ width: 22 }} />
                                    </span>
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: 'calc(50% + 20px)',
                                            transform: 'translate(-50%, -50%)',
                                        }}
                                        className={classes.actionStatistic}
                                    >
                                        {millify(reaction.totalDislike)}
                                    </div>
                                </span>
                            ) : userDetail && isCustomer ? (
                                <span
                                    className={classnames(classes.actionsIconV2, {
                                        [classes.disabled]: toggleReactionLoading,
                                    })}
                                    onClick={() => {
                                        handleReaction(ReactionType.Dislike);
                                    }}
                                >
                                    {reaction.dislike ? (
                                        <DislikeFill style={{ width: 22 }} />
                                    ) : (
                                        <BtnDislike style={{ width: 22 }} />
                                    )}
                                </span>
                            ) : null}
                        </div>
                    )}
                    {renderButtons(getActiveItem(list, activeItem))}
                </div>
            </div>
            {showDynamicItemDetail && (
                <DynamicLayoutItemDetail
                    userDetail={userDetail}
                    item={showDynamicItemDetail}
                    style={styleItemData}
                    handleClose={() => {
                        setShowDynamicItemDetail(null);
                        onSetActiveItem(0);
                    }}
                    reaction={reaction}
                    handleReaction={handleReaction}
                    toggleReactionLoading={toggleReactionLoading}
                    handleOpenFeedback={handleOpenFeedback}
                    handleViewFeedbackByStylist={handleViewFeedbackByStylist}
                    feedback={feedBack}
                    setSharing={setSharing}
                    getShareImage={getShareImage}
                />
            )}
            <BottomShareModal
                text={createShareMessage()}
                subject={
                    !getActiveItemIndex()
                        ? `Taffi Style: ${style_name}`
                        : `Taffi Item: ${list[activeItem]?.data?.title}`
                }
                open={sharing}
                onClose={() => {
                    setSharing(false);
                    setShareImage(null);
                }}
                onMoreSelect={() => {
                    return shareStyle();
                }}
                link={url!}
                moreLoading={gettingShareImage}
            />
            <MultiSelectPopup
                show={feedbackPopupShow}
                onClose={handleCloseMultiSelectPopup}
                title={STRINGS.ADD_FEEDBACK}
                options={feedbackOptions}
                selectedOptions={selectedFeedbacks}
                setSelectedOptions={setSelectedFeedbacks}
                loading={getFeedbackOptionsLoading || getCustomerFeedbackLoading}
                handleSubmit={handleSubmitFeedback}
                customValueError={customValueError}
                setCustomValueError={setCustomValueError}
                setHidePopup={setFeedbackPopupShow}
                successMessage={STRINGS.FEEDBACK_RECEIVED}
                successDetails={STRINGS.FEEDBACK_SUCCESS_MESSAGE}
                submitLoading={createFeedbackLoading || updateFeedbackLoading}
            />
            {consumersFeedbacksPopupShow && (
                <WidgetPopup
                    titlePopup="Consumer Feedback"
                    widgetCode={WidgetCode.ConsumerFeedback}
                    onClose={() => setConsumersFeedbacksPopupShow(false)}
                    widgetProps={{
                        docId: list[activeItem]?.id,
                    }}
                />
            )}
        </div>
    );
}

export default StyleItem;
